// Auto-generated file - do not edit manually
export const LOCALE_HASH = '6383dd79';
